import de from '@translations/de/uploadInput.json';
import en from '@translations/en/uploadInput.json';
import pl from '@translations/pl/uploadInput.json';
import sl from '@translations/sl/uploadInput.json';
import uk from '@translations/uk/uploadInput.json';
import bg from '@translations/bg/uploadInput.json';
import cz from '@translations/cz/uploadInput.json';
import fr from '@translations/fr/uploadInput.json';
import gr from '@translations/gr/uploadInput.json';
import it from '@translations/it/uploadInput.json';
import pr from '@translations/pr/uploadInput.json';
import ru from '@translations/ru/uploadInput.json';
import sk from '@translations/sk/uploadInput.json';
import sp from '@translations/sp/uploadInput.json';
import tr from '@translations/tr/uploadInput.json';
import hu from '@translations/hu/uploadInput.json';
import { ITranslations } from '@/types/common';
import { UploadInputTransFields } from './types';

export const uploadInputTranslations: ITranslations<UploadInputTransFields> = {
  name: 'uploadInput',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
